import DrawerFooter from '@/components/DrawerFooter'
import i18n, { LanguageEnum, useTranslation } from '@/services/i18n'
import { Button, Col, Drawer, Form, Input, Radio, Row, Modal as antdModal } from 'antd'
import React, { memo, useEffect, useRef, useState } from 'react'
import Webcam from 'react-webcam'
import styles from './index.module.scss'
import { ReactComponent as CloseModalIcon } from '@/assets/icons/closeModal.svg'
import QrCode from '@/assets/images/qrCode.png'
import Modal from '@/components/Modal'
import { isEqual } from 'lodash'
import jsQR from 'jsqr'
import { ChainlistModel } from '@/services/apis/base/models'
import {
  AddressBookModel,
  AutoSweepRuleModel,
  ErrorCodeTypeEnum,
} from '@/services/apis/policy/model'
import policy from '@/services/apis/policy'
import { getconditionText } from '@/utils/setting'
import { PolicyItemModel, PolicyTypeEnum, WhiteListAuditStatus } from '@/constants/enum'
import { useNavigate } from 'react-router-dom'
import { useGetSweepGray } from '@/hooks/sweep'
import { ParseQrcode, queryRules } from '@/utils/whiteListUtils'
import StrategyDetailModal from '@/components/StrategyDetailModal'
import WarnTitle from '@/assets/images/warnTitle.png'
interface WhiteDrawerProps {
  open: boolean
  onClose: () => void
  currentItem?: AddressBookModel
  chainList: ChainlistModel[]
  getAddressBookList: Function
}
interface FormValuesProps {
  addressName: string
  address: string
  type: string
}
const WhiteListDrawer = memo<WhiteDrawerProps>(
  ({ open, onClose, currentItem, chainList, getAddressBookList }) => {
    const { t } = useTranslation()
    const [whiteListForm] = Form.useForm<FormValuesProps>()
    const formValues = Form.useWatch([], whiteListForm)
    const [isDisabled, setIsDisabled] = useState(true)
    const [preState, setPreState] = useState({})

    const handleClose = () => {
      whiteListForm.resetFields()

      onClose()
    }

    const navigate = useNavigate()
    // 判断disable状态
    useEffect(() => {
      whiteListForm
        .validateFields({ validateOnly: true })
        .then(values => {
          // 判断是否进行了修改

          if (isEqual(values, {})) {
            return
          }

          if (currentItem && isEqual(values, preState)) {
            setIsDisabled(true)
            return
          }
          setIsDisabled(false)
        })
        .catch((err: any) => {
          if (err.errorFields.length > 0) {
            setIsDisabled(true)
            return
          }
        })
    }, [formValues])
    // 判断是否进行了修改
    useEffect(() => {
      if (currentItem) {
        whiteListForm.setFieldsValue({
          address: currentItem.address,
          addressName: currentItem.addressName,
          type: currentItem.blockchainTypeKey,
        })

        setPreState({
          address: currentItem.address,
          addressName: currentItem.addressName,
          type: currentItem.blockchainTypeKey,
        })
      }
    }, [currentItem])
    // 点击粘贴
    const handlePaste = async () => {
      const res = await navigator.clipboard.readText()
      whiteListForm.setFieldValue(['address'], res)
      whiteListForm.validateFields(['address'])
    }
    const webcamRef = useRef<any>(null)
    const canvasRef = useRef<any>(null)
    const intervalId = useRef<any>(null)
    // 打开摄像头
    const openWebcam = () => {
      const modal = Modal.info({
        title: (
          <div style={{ display: 'flex', justifyContent: 'center' }}>{t('whiteList.scan')}</div>
        ),
        content: (
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Webcam
              audio={false}
              height={300}
              ref={webcamRef}
              screenshotFormat="image/jpeg"
              width={400}
            />
          </div>
        ),
        footer: null,
        closable: true,
        icon: null,
        afterClose: () => clearInterval(intervalId.current), // 关闭摄像头时清除定时器
      })
      // 打开摄像头时持续获取图像数据
      setIntervalImg(modal)
    }
    // 处理二维码
    const setIntervalImg = (modal: {
      destroy: () => void
      update: (configUpdate: any) => void
    }) => {
      intervalId.current = setInterval(() => {
        if (webcamRef.current) {
          const video = webcamRef.current.video
          const imageData = ParseQrcode(video, canvasRef.current)
          if (imageData) {
            const code = jsQR(imageData.data, imageData.width, imageData.height)
            if (code) {
              whiteListForm.setFieldValue(['address'], code.data)
              whiteListForm.validateFields(['address'])
              modal.destroy()
            }
          }
        }
      }, 1000)
    }

    // 跳转到策略
    const handleRule = (record: PolicyItemModel) => {
      Modal.info({
        footer: null,
        title: t('policy.sendDetail'),
        content: <StrategyDetailModal type={PolicyTypeEnum.SEND} record={record} />,
        closable: true,
      })
    }

    // 判断是否有自动归集的权限
    const isOpenedSweep = useGetSweepGray()
    // 跳转到自动归集
    const handleSweepRule = (key: string) => {
      if (isOpenedSweep) {
        navigate(`/application/autoSweep`, { state: { modifyKey: key } })
        antdModal.destroyAll()
      } else {
        Modal.info({
          title: t('autoSweep.permission'),
          content: <div className={styles.confirm}>{t('autoSweep.noPermission')}</div>,
          okText: t('common.complete'),
          closable: true,
        })
      }
    }

    // 展示影响的策略
    const getRuleList = (autoSweepRule: AutoSweepRuleModel[], txRule: PolicyItemModel[]) => {
      return (
        <div>
          {txRule?.map((item, index) => {
            return (
              <div className={styles.rule} onClick={() => handleRule(item)} key={index}>
                {getconditionText(item)}
              </div>
            )
          })}
          {autoSweepRule?.map((item, index) => {
            return (
              <div
                onClick={() => handleSweepRule(item.modifyKey)}
                key={index}
                className={styles.rule}
              >{`${t('whiteList.autoSweepRule')}: ${item.blockchainTypeName}`}</div>
            )
          })}
        </div>
      )
    }
    const checkPhishing = (isPhishing: boolean) => {
      return new Promise<boolean>((resolve, reject) => {
        if (isPhishing) {
          Modal.confirm({
            title: t('record.fraudulentAddressTip'),
            content: t('record.fraudulentAddressWhiteList'),
            okText: t('common.continue'),
            icon: <img src={WarnTitle} alt="" style={{ height: '46px', width: '46px' }}></img>,
            closable: true,
            onOk() {
              resolve(true)
            },
            onCancel() {
              resolve(false)
            },
            wrapClassName: styles.warningWarpper,
          })
          return
        } else {
          resolve(true)
        }
      })
    }
    // 更新白名单
    const handleUpdate = async (id: string) => {
      const res = await policy.updateAddressBook({
        name: formValues.addressName,
        address: formValues.address,
        addressBookKey: id,
        timestamp: new Date().getTime(),
      })
      if (res.code === ErrorCodeTypeEnum.TRANSACTIONEXIST) {
        handleClose()
        Modal.info({
          title: t('whiteList.editApprovalInfo'),
          content: null,
          wrapClassName: styles.editInfoModal,
        })
      } else if (
        res.code === ErrorCodeTypeEnum.ADRESSDUPLICATION ||
        res.code === ErrorCodeTypeEnum.FORMATERROR
      ) {
        setErrMsgAddress(res?.message)
        setIsDisabled(true)
      } else if (res.code === ErrorCodeTypeEnum.NAMEDUPLICATION) {
        setErrMsgName(res?.message)
        setIsDisabled(true)
      } else if (res.success) {
        handleClose()
        // 重新获取数据
        getAddressBookList(new Date().getTime())
      }
    }
    // 处理错误信息
    const [errMsgName, setErrMsgName] = useState<string>()
    const [errMsgAddress, setErrMsgAddress] = useState<string>()
    const [btnLoading, setBtnLoading] = useState(false)
    // 保存并提交
    const handleSaveAndSubmission = async () => {
      // 修改
      if (currentItem) {
        let { data: isPhishing } = await policy.existsPhishingAddress({
          address: formValues.address,
        })
        const res1 = await checkPhishing(isPhishing)
        if (!res1) {
          setBtnLoading(false)
          return
        }
        // 如果未通过不需要二次确认
        if (currentItem.auditStatus === WhiteListAuditStatus.REJECT) {
          setBtnLoading(true)
          await handleUpdate(currentItem.addressBookKey)
          setBtnLoading(false)
          return
        }
        // 查询是否有关联策略
        setBtnLoading(true)
        const { autoSweepRes, txRes } = await queryRules(currentItem.addressBookKey)
        setBtnLoading(false)
        Modal.confirm({
          title: t('tx.nonceConfirmTitle'),
          content: (
            <div className={styles.editModal}>
              <div className={styles.text}>{t('whiteList.editInfo')}</div>
              {(autoSweepRes.data || txRes.data) && (
                <div className={styles.card}>
                  <div style={{ fontSize: '14px', paddingBottom: '4px' }}>
                    {t('whiteList.editCardText')}
                  </div>
                  {getRuleList(autoSweepRes.data, txRes.data)}
                </div>
              )}
            </div>
          ),
          okText: t('common.save'),
          onOk: () => handleUpdate(currentItem.addressBookKey),
          onCancel: () => antdModal.destroyAll(),
        })

        // 添加
      } else {
        setBtnLoading(true)
        let { data: isPhishing } = await policy.existsPhishingAddress({
          address: formValues.address,
        })
        const res1 = await checkPhishing(isPhishing)
        if (!res1) {
          setBtnLoading(false)
          return
        }

        const res = await policy.addAddressBook({
          name: formValues.addressName,
          address: formValues.address,
          blockchainTypeKey: formValues.type,
        })
        setBtnLoading(false)
        // 如果校验有问题，需要复现到页面
        if (res.code === ErrorCodeTypeEnum.NAMEDUPLICATION) {
          setErrMsgName(res?.message)
          setIsDisabled(true)
          return
        } else if (
          res.code === ErrorCodeTypeEnum.ADRESSDUPLICATION ||
          res.code === ErrorCodeTypeEnum.FORMATERROR
        ) {
          setErrMsgAddress(res?.message)
          setIsDisabled(true)
          return
        } else if (res.success) {
          const signRes = await policy.addWhiteListSign({
            addressBookKey: res.data,
            timestamp: new Date().getTime(),
          })
          handleClose()
          if (signRes.success) {
            Modal.info({
              title: t('whiteList.addSuccessTitle'),
              content: (
                <div style={{ margin: '40px 0 40px 50px' }}>{t('whiteList.addSuccessContent')}</div>
              ),
            })
            // 重新获取数据
            getAddressBookList(new Date().getTime())
          }
        }
      }
    }

    const [chainDesc, setChainDesc] = useState<ChainlistModel[]>(
      chainList.filter(item => item.addressGroupDesc)
    )
    // 获取到有对应desc的链
    useEffect(() => {
      setChainDesc(chainList.filter(item => item.addressGroupDesc))
    }, [chainList])
    // 处理链信息描述
    const [radioDesc, setRadioDesc] = useState<string>()
    useEffect(() => {
      const res = chainDesc.find(item => item.blockchainTypeKey === formValues?.type)

      if (res) {
        setRadioDesc(res?.addressGroupDesc)
      } else {
        setRadioDesc(undefined)
      }
    }, [formValues?.type])
    // 错误信息重置
    useEffect(() => {
      setErrMsgName(undefined)
    }, [formValues?.addressName])
    useEffect(() => {
      setErrMsgAddress(undefined)
    }, [formValues?.address])
    return (
      <>
        <Drawer
          title={!currentItem ? t('whiteList.addWhiteList') : t('whiteList.editWhiteLIst')}
          open={open}
          footer={null}
          width={560}
          maskClosable={false}
          destroyOnClose={true}
          placement="right"
          closable={false}
          extra={
            <div onClick={handleClose} className={styles.closeIcon}>
              <CloseModalIcon />
            </div>
          }
          afterOpenChange={() => {
            setErrMsgName(undefined)
            setErrMsgAddress(undefined)
          }}
        >
          <div className={styles.container}>
            <Form name="whiteList" labelWrap={false} form={whiteListForm} requiredMark={false}>
              <div className={styles.formTitle}>{t('whiteList.addressTitle')}</div>
              <Form.Item
                name="addressName"
                rules={[{ required: true, message: t('whiteList.ruleName') as string }]}
                validateStatus={errMsgName && 'error'}
                help={errMsgName}
              >
                <Input placeholder={t('whiteList.addressPla') as string} maxLength={20} />
              </Form.Item>
              <div className={styles.formTitle}>{t('record.txType')}</div>
              <Form.Item name="type" rules={[{ required: true }]} noStyle>
                {currentItem ? (
                  <Radio value={currentItem.blockchainTypeKey} defaultChecked={true}>
                    {currentItem.blockchainTypeName}
                  </Radio>
                ) : (
                  <Radio.Group size="large" className={styles.sweepRateGroup}>
                    <Row gutter={[0, 16]}>
                      {chainList.map((val, index) => (
                        <Col span={6} key={index}>
                          <Radio value={val.blockchainTypeKey} key={val.blockchainTypeKey}>
                            {val.blockchainTypeName}
                          </Radio>
                        </Col>
                      ))}
                    </Row>
                  </Radio.Group>
                )}
              </Form.Item>
              {radioDesc && <div className={styles.radioDesc}>{radioDesc}</div>}
              <div className={styles.addressTitle}>
                <span>{t('common.address')}</span>
                <div className={styles.rightAction}>
                  <img
                    src={QrCode}
                    alt=""
                    style={{
                      width: '16px',
                      height: '16px',
                      marginRight: '10px',
                      cursor: 'pointer',
                    }}
                    onClick={openWebcam}
                  />
                  <Button type="link" onClick={handlePaste} style={{ lineHeight: 1 }}>
                    {t('whiteList.paste')}
                  </Button>
                </div>
              </div>
              <Form.Item
                name="address"
                rules={[{ required: true, message: t('whiteList.ruleAddress') as string }]}
                validateStatus={errMsgAddress && 'error'}
                help={errMsgAddress}
              >
                <Input placeholder={t('whiteList.whiteAddressPla') as string} />
              </Form.Item>
            </Form>
            <DrawerFooter>
              <Button className={styles.btn} onClick={handleClose}>
                {t('common.cancel')}
              </Button>
              <Button
                className={styles.btn}
                type="primary"
                disabled={isDisabled}
                style={
                  i18n.language === LanguageEnum.EN_US ? { width: '220px' } : { width: '180px' }
                }
                onClick={() => handleSaveAndSubmission()}
                loading={btnLoading}
              >
                {t('autoSweep.saveAndSubmission')}
              </Button>
            </DrawerFooter>
          </div>
        </Drawer>
      </>
    )
  }
)

export default WhiteListDrawer
